import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Header from "../Landingpage/Subcomponents/Header";
import { Trans } from "react-i18next";

const NotVerified = ({ currentLanguage, setCurrentLanguage }) => {
  const { t } = useTranslation();

  const url = "https://mymediaplanner.com/requestemailvalidation";
  return (
    <Header
      currentLanguage={currentLanguage}
      setCurrentLanguage={setCurrentLanguage}
    >
      <Row>
        <Col md={12} style={{ textAlign: "center" }}>
          <Trans
            i18nKey="Account.Register.NotVerified"
            components={{
              // eslint-disable-next-line jsx-a11y/heading-has-content
              h3: <h3 />,
              bold: <strong />,
              em: <em />,
              br: <br />, // for line breaks in the translation
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              anchor: <a href={url} target="_blank" rel="noopener noreferrer"></a>
            }}
          />
        </Col>
      </Row>
    </Header>
  );
};

export default NotVerified;
